/**
 * @generated SignedSource<<64a5e4674c1bade53314ef27ca3dc53e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AutoRecordRuleFilterOrganizer = "ANYONE" | "SELF";
export type AutoRecordRuleLevel = "GROUP" | "USER" | "WORKSPACE";
export type AutoRecordRuleType = "RECORD" | "RESTRICT";
export type FilterAttendeeType = "EXTERNAL_ONLY" | "INTERNAL_AND_EXTERNAL" | "INTERNAL_ONLY";
import { FragmentRefs } from "relay-runtime";
export type CustomRulesSettings$data = {
  readonly account: {
    readonly " $fragmentSpreads": FragmentRefs<"AutoRecordRulesListItemRuleDescriptionTooltips" | "AutoRecordRulesListItemWorkspacePill" | "CreateAndEditModalAccount">;
  };
  readonly autoRecordRules: ReadonlyArray<{
    readonly filterAttendeeType: FilterAttendeeType;
    readonly filterKeywordsContains: ReadonlyArray<string | null> | null;
    readonly filterKeywordsRestrict: ReadonlyArray<string | null> | null;
    readonly filterMaximumAttendees: number | null;
    readonly filterMinimumAttendees: number | null;
    readonly filterOrganizer: AutoRecordRuleFilterOrganizer;
    readonly id: string;
    readonly ruleLevel: AutoRecordRuleLevel;
    readonly ruleType: AutoRecordRuleType;
    readonly " $fragmentSpreads": FragmentRefs<"AutoRecordRulesListItemAppliesTo" | "AutoRecordRulesListItemDuplicateAutoRecordRule" | "AutoRecordRulesListItemRule" | "AutoRecordRulesListItemRuleDeletionConfirmModal" | "CreateAndEditModalRule">;
  }>;
  readonly " $fragmentType": "CustomRulesSettings";
};
export type CustomRulesSettings$key = {
  readonly " $data"?: CustomRulesSettings$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomRulesSettings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomRulesSettings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CreateAndEditModalAccount"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AutoRecordRulesListItemWorkspacePill"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AutoRecordRulesListItemRuleDescriptionTooltips"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AutoRecordRule",
      "kind": "LinkedField",
      "name": "autoRecordRules",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AutoRecordRulesListItemRule"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ruleType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ruleLevel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filterAttendeeType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filterMinimumAttendees",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filterMaximumAttendees",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filterKeywordsContains",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filterKeywordsRestrict",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filterOrganizer",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AutoRecordRulesListItemAppliesTo"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AutoRecordRulesListItemRuleDeletionConfirmModal"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AutoRecordRulesListItemDuplicateAutoRecordRule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CreateAndEditModalRule"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ec7957318a03c550f84270140b693437";

export default node;
